import {
  MemberSetting,
  MemberSettingLocationConfig,
} from '@deckee/api-app-main';
import {
  createAction as rtkCreateAction,
  createAsyncThunk,
} from '@reduxjs/toolkit';
import { AppAsyncThunkAPI, getStore } from '../..';
import { SignalAppearanceTypes } from '../../../../components/features/Signal/components/SignalAppearanceChoices/SignalAppearance.types';
import { callEndpoint, telemetry } from '../../../backend';
import { uploadAndDelete } from '../../../event-capture/anonymous-data-capture';
import { throttledFetchAndBuildDataSource } from '../../../map-layer/image-layers/signal-markers';
import { updateData as updateCurrentLocationPulse } from '../../../map-layer/image-layers/current-location-markers';
import { api } from './api';
import { getCurrentPositionOrMapCenter } from '../../../geo';

// ------------------------------------
// Constants
// ------------------------------------

export const APP_CONTROLS_MANAGER_SET_BASE_MAP =
  'APP_CONTROLS_MANAGER_SET_BASE_MAP';
export const APP_CONTROLS_MANAGER_SET_LOCATION_DISCLOSURE_MODAL =
  'APP_CONTROLS_MANAGER_SET_LOCATION_DISCLOSURE_MODAL';
export const APP_CONTROLS_UPDATE_ACTIVE_WEATHER_ALERTS =
  'APP_CONTROLS_UPDATE_ACTIVE_WEATHER_ALERTS';
export const APP_CONTROLS_UPDATE_ACTIVE_ALERTS =
  'APP_CONTROLS_UPDATE_ACTIVE_ALERTS';
export const APP_CONTROLS_MANAGER_SET_SIDE_BAR =
  'APP_CONTROLS_MANAGER_SET_SIDE_BAR';
export const APP_CONTROLS_MANAGER_SET_MAIN_MENU =
  'APP_CONTROLS_MANAGER_SET_MAIN_MENU';
export const APP_CONTROLS_MANAGER_SHOW_MAP_OVERLAY =
  'APP_CONTROLS_MANAGER_SHOW_MAP_OVERLAY';
export const APP_CONTROLS_MANAGER_SHOW_PAGE_HOLDER =
  'APP_CONTROLS_MANAGER_SHOW_PAGE_HOLDER';
export const APP_CONTROLS_MANAGER_SHOW_CONTROL_BAR =
  'APP_CONTROLS_MANAGER_SHOW_CONTROL_BAR';

export const APP_CONTROLS_MANAGER_SET_SIDE_BAR_NO_MAIN_MENU =
  'APP_CONTROLS_MANAGER_SET_SIDE_BAR_NO_MAIN_MENU';
export const APP_CONTROLS_MANAGER_SET_SIDE_BAR_WITH_HARD_OVERLAY =
  'APP_CONTROLS_MANAGER_SET_SIDE_BAR_WITH_HARD_OVERLAY';
export const APP_CONTROLS_MANAGER_SET_FLOATING_PANE =
  'APP_CONTROLS_MANAGER_SET_FLOATING_PANE';
export const APP_CONTROLS_MANAGER_SET_FLOATING_PANE_WITH_OVERLAY =
  'APP_CONTROLS_MANAGER_SET_FLOATING_PANE_WITH_OVERLAY';
export const APP_CONTROLS_MANAGER_HIDE_MAP_CONTROLS =
  'APP_CONTROLS_MANAGER_HIDE_MAP_CONTROLS';
export const APP_CONTROLS_MANAGER_HIDE_SEARCH_BUTTON =
  'APP_CONTROLS_MANAGER_HIDE_SEARCH_BUTTON';
export const APP_CONTROLS_MANAGER_HIDE_BOTTOM_CONTROL_PANE =
  'APP_CONTROLS_MANAGER_HIDE_BOTTOM_CONTROL_PANE';

export const APP_CONTROLS_MANAGER_SET_MEASURE_DISTANCE =
  'APP_CONTROLS_MANAGER_SET_MEASURE_DISTANCE';
export const APP_CONTROLS_MANAGER_SET_NOTIFS =
  'APP_CONTROLS_MANAGER_SET_NOTIFS';
export const APP_CONTROLS_MANAGER_SET_FLOATING_PANE_WITH_MENU_AND_SEARCH =
  'APP_CONTROLS_MANAGER_SET_FLOATING_PANE_WITH_MENU_AND_SEARCH';
export const APP_CONTROLS_MANAGER_SET_NEW_MARKER_ENTITY_TYPE =
  'APP_CONTROLS_MANAGER_SET_NEW_MARKER_ENTITY_TYPE';
export const APP_CONTROLS_MANAGER_SET_NEW_MARKER_CONTENT =
  'APP_CONTROLS_MANAGER_SET_NEW_MARKER_CONTENT';
export const APP_CONTROLS_MANAGER_SHOW_SLIDE_UP_MENU =
  'APP_CONTROLS_MANAGER_SHOW_SLIDE_UP_MENU';
export const APP_CONTROLS_MANAGER_SET_MARKER_SUMMARY =
  'APP_CONTROLS_MANAGER_SET_MARKER_SUMMARY';

export const APP_CONTROLS_MANAGER_SET_MARKER_SUMMARY_DETAILS =
  'APP_CONTROLS_MANAGER_SET_MARKER_SUMMARY_DETAILS';
export const APP_CONTROLS_MANAGER_SET_MARKER_EDIT =
  'APP_CONTROLS_MANAGER_SET_MARKER_EDIT';
export const APP_CONTROLS_MANAGER_SET_MARKER_FLAG =
  'APP_CONTROLS_MANAGER_SET_MARKER_FLAG';

export const APP_CONTROLS_MANAGER_SET_MY_TRIPS =
  'APP_CONTROLS_MANAGER_SET_MY_TRIPS';
export const APP_CONTROLS_MANAGER_CLOSE_POPOVER =
  'APP_CONTROLS_MANAGER_CLOSE_POPOVER';
export const APP_CONTROLS_MANAGER_SHOW_POPOVER =
  'APP_CONTROLS_MANAGER_SHOW_POPOVER';
export const APP_CONTROLS_MANAGER_SHOW_POPOVER_MESSAGE =
  'APP_CONTROLS_MANAGER_SHOW_POPOVER_MESSAGE';

export const APP_CONTROLS_MANAGER_SET_NEW_MARKER_COMMENT =
  'APP_CONTROLS_MANAGER_SET_NEW_MARKER_COMMENT';

export const APP_CONTROLS_MANAGER_SET_WEATHER =
  'APP_CONTROLS_MANAGER_SET_WEATHER';
export const APP_CONTROLS_MANAGER_SET_WEATHER_LOCATION_SEARCH =
  'APP_CONTROLS_MANAGER_SET_WEATHER_LOCATION_SEARCH';

export const APP_CONTROLS_MANAGER_SET_TRIP_SETTINGS =
  'APP_CONTROLS_MANAGER_SET_TRIP_SETTINGS';

export const APP_CONTROLS_MANAGER_SET_MAP_OPTIONS =
  'APP_CONTROLS_MANAGER_SET_MAP_OPTIONS';
export const APP_CONTROLS_MANAGER_SET_MAP_OPTIONS_NAV =
  'APP_CONTROLS_MANAGER_SET_MAP_OPTIONS_NAV';

// ## Safety Information ##
export const APP_CONTROLS_MANAGER_SET_SAFETY_INFORMATION =
  'APP_CONTROLS_MANAGER_SET_SAFETY_INFORMATION';
export const APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSW =
  'APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSW';
export const APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSW_CHECKLIST =
  'APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSW_CHECKLIST';
export const APP_CONTROLS_MANAGER_SET_SAFETY_INFO_WA =
  'APP_CONTROLS_MANAGER_SET_SAFETY_INFO_WA';
export const APP_CONTROLS_MANAGER_SET_SAFETY_INFO_WA_DEPARTMENTS =
  'APP_CONTROLS_MANAGER_SET_SAFETY_INFO_WA_DEPARTMENTS';
export const APP_CONTROLS_MANAGER_SET_SAFETY_INFO_TAS =
  'APP_CONTROLS_MANAGER_SET_SAFETY_INFO_TAS';
export const APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSBC =
  'APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSBC';

export const APP_CONTROLS_MANAGER_SET_MEMBER_DETAILS =
  'APP_CONTROLS_MANAGER_SET_MEMBER_DETAILS';
export const APP_CONTROLS_MANAGER_SET_SETTINGS =
  'APP_CONTROLS_MANAGER_SET_SETTINGS';
export const APP_CONTROLS_MANAGER_SET_SETTINGS_FEATURES =
  'APP_CONTROLS_MANAGER_SET_SETTINGS_FEATURES';
export const APP_CONTROLS_MANAGER_SET_SETTINGS_HELM =
  'APP_CONTROLS_MANAGER_SET_SETTINGS_HELM';
export const APP_CONTROLS_MANAGER_SET_SETTINGS_HELM_OVERRIDE =
  'APP_CONTROLS_MANAGER_SET_SETTINGS_HELM_OVERRIDE';
export const APP_CONTROLS_MANAGER_SET_ABOUT = 'APP_CONTROLS_MANAGER_SET_ABOUT';
export const APP_CONTROLS_MANAGER_SET_GET_NOTIFIED =
  'APP_CONTROLS_MANAGER_SET_GET_NOTIFIED';

export const APP_CONTROLS_MANAGER_SET_PROFILE =
  'APP_CONTROLS_MANAGER_SET_PROFILE';
export const APP_CONTROLS_MANAGER_BOAT_DETAILS_EDIT =
  'APP_CONTROLS_MANAGER_BOAT_DETAILS_EDIT';

export const APP_CONTROLS_MANAGER_SET_LOCATION_SEARCH =
  'APP_CONTROLS_MANAGER_SET_LOCATION_SEARCH';
export const APP_CONTROLS_MANAGER_SET_EMAIL_AUTHENTICATION =
  'APP_CONTROLS_MANAGER_SET_EMAIL_AUTHENTICATION';
export const APP_CONTROLS_MANAGER_SET_404 = 'APP_CONTROLS_MANAGER_SET_404';

export const APP_CONTROLS_MANAGER_UPDATE_ROUTE_LOCATION_ON_LOAD =
  'APP_CONTROLS_MANAGER_UPDATE_ROUTE_LOCATION_ON_LOAD';
export const APP_CONTROLS_MANAGER_HIDE_ALL_LAYERS =
  'APP_CONTROLS_MANAGER_HIDE_ALL_LAYERS';
// export const APP_CONTROLS_MANAGER_SHOW_ALL_LAYERS = 'APP_CONTROLS_MANAGER_SHOW_ALL_LAYERS';
export const APP_CONTROLS_MANAGER_UPDATE_SELECTED_BASE_MAP_LAYER =
  'APP_CONTROLS_MANAGER_UPDATE_SELECTED_BASE_MAP_LAYER';
export const APP_CONTROLS_MANAGER_MOVE_MAP_TO_LOCATION =
  'APP_CONTROLS_MANAGER_MOVE_MAP_TO_LOCATION';
export const APP_CONTROLS_MANAGER_MOVE_MAP_TO_CURRENT_LOCATION =
  'APP_CONTROLS_MANAGER_MOVE_MAP_TO_CURRENT_LOCATION';
export const APP_CONTROLS_MANAGER_UPDATE_SELECTED_MARKER =
  'APP_CONTROLS_MANAGER_UPDATE_SELECTED_MARKER';
export const APP_CONTROLS_MANAGER_UPDATE_TOAST_MESSAGE =
  'APP_CONTROLS_MANAGER_UPDATE_TOAST_MESSAGE';
export const APP_CONTROLS_MANAGER_CLEAR_MAP_LOCATION_CHANGE =
  'APP_CONTROLS_MANAGER_CLEAR_MAP_LOCATION_CHANGE';

export const APP_CONTROLS_MANAGER_UPDATE_MEMBER_SETTINGS =
  'APP_CONTROLS_MANAGER_UPDATE_MEMBER_SETTINGS';
export const APP_CONTROLS_SET_TRANSPARENT_STATUS_BAR =
  'APP_CONTROLS_SET_TRANSPARENT_STATUS_BAR';

export const APP_CONTROLS_SET_HIDE_STATUS_BAR =
  'APP_CONTROLS_SET_HIDE_STATUS_BAR';
export const APP_CONTROLS_MANAGER_LOG_OUT_RESET =
  'APP_CONTROLS_MANAGER_LOG_OUT_RESET';
export const APP_CONTROLS_UPDATE_PUBLIC_LOCATION =
  'APP_CONTROLS_UPDATE_PUBLIC_LOCATION';

export const APP_CONTROLS_MANAGER_SHOW_LOCATION_MAP_MARKER =
  'APP_CONTROLS_MANAGER_SHOW_LOCATION_MAP_MARKER';

export const APP_CONTROLS_MANAGER_UPDATE_CURRENT_MAP_PARAMS =
  'APP_CONTROLS_MANAGER_UPDATE_CURRENT_MAP_PARAMS';
export const APP_CONTROLS_MANAGER_UPDATE_APP_VIEWPORT_SIZE =
  'APP_CONTROLS_MANAGER_UPDATE_APP_VIEWPORT_SIZE';

export const APP_CONTROLS_MANAGER_SHOW_SELECT_MAP_POINT =
  'APP_CONTROLS_MANAGER_SHOW_SELECT_MAP_POINT';

export const APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE =
  'APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE';
export const APP_CONTROLS_MANAGER_HIDE_CONTROL_PANE =
  'APP_CONTROLS_MANAGER_HIDE_CONTROL_PANE';
export const APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_ZOOM =
  'APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_ZOOM';
export const APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_RESET =
  'APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_RESET';
export const APP_CONTROLS_MANAGER_HIDE_CONTROL_PANE_RESET =
  'APP_CONTROLS_MANAGER_HIDE_CONTROL_PANE_RESET';
export const APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_CURRENT_LOCATION =
  'APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_CURRENT_LOCATION';
export const APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_SETTINGS =
  'APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_SETTINGS';

export const APP_CONTROLS_MANAGER_SHOW_FOLLOW_BUTTON =
  'APP_CONTROLS_MANAGER_SHOW_FOLLOW_BUTTON';
export const APP_CONTROLS_MANAGER_HIDE_FOLLOW_BUTTON =
  'APP_CONTROLS_MANAGER_HIDE_FOLLOW_BUTTON';

export const APP_CONTROLS_UPDATE_SHARE_NOTIFICATIONS =
  'APP_CONTROLS_UPDATE_SHARE_NOTIFICATIONS';

export const APP_CONTROLS_MANAGER_SET_FLOATING_PANE_OFFSET =
  'APP_CONTROLS_MANAGER_SET_FLOATING_PANE_OFFSET';
export const APP_CONTROLS_MANAGER_SET_SHOWING_MENU_BAR =
  'APP_CONTROLS_MANAGER_SET_SHOWING_MENU_BAR';
export const APP_CONTROLS_MANAGER_SET_DROP_PIN_LOCATION =
  'APP_CONTROLS_MANAGER_SET_DROP_PIN_LOCATION';
export const APP_CONTROLS_MANAGER_RESET_MAP_HOLDER_OFFSET =
  'APP_CONTROLS_MANAGER_RESET_MAP_HOLDER_OFFSET';

/**
 * Creates an action
 *
 * @param type
 * @param payload
 * @param options
 * @return {Object}
 */
const createAction = (
  type: string,
  payload: any = undefined,
  options = {},
) => ({
  type,
  payload,
  ...options,
});

// ------------------------------------
// Actions
// ------------------------------------
/* eslint-disable max-len */
export const setBaseMap = () => createAction(APP_CONTROLS_MANAGER_SET_BASE_MAP);
export const setLocationDisclosureModal = () =>
  createAction(APP_CONTROLS_MANAGER_SET_LOCATION_DISCLOSURE_MODAL);
export const setMainMenu = () =>
  createAction(APP_CONTROLS_MANAGER_SET_MAIN_MENU);
export const setMeasureDistance = () =>
  createAction(APP_CONTROLS_MANAGER_SET_MEASURE_DISTANCE);

export const setSideBar = () => createAction(APP_CONTROLS_MANAGER_SET_SIDE_BAR);
export const setSideBarNoMenu = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SIDE_BAR_NO_MAIN_MENU);
export const setSideBarWithHardOverlay = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SIDE_BAR_WITH_HARD_OVERLAY);
export const setFloatingPane = () =>
  createAction(APP_CONTROLS_MANAGER_SET_FLOATING_PANE);
export const setFloatingPaneWithOverlay = () =>
  createAction(APP_CONTROLS_MANAGER_SET_FLOATING_PANE_WITH_OVERLAY);
export const showPageHolder = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SHOW_PAGE_HOLDER, passedProps);
export const showControlBar = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SHOW_CONTROL_BAR, passedProps);
export const setShowMapOverlay = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SHOW_MAP_OVERLAY, passedProps);
export const hideMapControls = () =>
  createAction(APP_CONTROLS_MANAGER_HIDE_MAP_CONTROLS);

// New marker routes
export const setNewMarkerEntityType = () =>
  createAction(APP_CONTROLS_MANAGER_SET_NEW_MARKER_ENTITY_TYPE);
export const setNewMarkerContent = () =>
  createAction(APP_CONTROLS_MANAGER_SET_NEW_MARKER_CONTENT);

export const closePopover = () =>
  createAction(APP_CONTROLS_MANAGER_CLOSE_POPOVER);
export const showPopover = (passedProps: any, heading = '') =>
  createAction(APP_CONTROLS_MANAGER_SHOW_POPOVER, passedProps, { heading });
export const showPopoverMessage = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SHOW_POPOVER_MESSAGE, passedProps); // Default message popover

export const setMarkerSummary = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_MARKER_SUMMARY, passedProps); // Marker popover

export const setMarkerSummaryDetails = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_MARKER_SUMMARY_DETAILS, passedProps); // static marker details
export const setMarkerDetails = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_MARKER_SUMMARY_DETAILS, passedProps); // MarkerDetails
export const setMarkerCommentDetails = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_NEW_MARKER_COMMENT, passedProps); // MarkerCommentDetails

export const updateActiveWeatherAlerts = (hasWeatherAlerts: boolean) =>
  createAction(APP_CONTROLS_UPDATE_ACTIVE_WEATHER_ALERTS, hasWeatherAlerts);
export const updateActiveAlerts = (hasAlerts: boolean) =>
  createAction(APP_CONTROLS_UPDATE_ACTIVE_ALERTS, hasAlerts);

export const setNewMarkerComment = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_NEW_MARKER_COMMENT, passedProps); // setNewMarkerComment
export const setMarkerEdit = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_MARKER_EDIT, passedProps); // setMarkerEdit
export const setMarkerFlag = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_MARKER_FLAG, passedProps); // setMarkerFlag

export const setMyTrips = () => createAction(APP_CONTROLS_MANAGER_SET_MY_TRIPS);
export const setNotifs = () => createAction(APP_CONTROLS_MANAGER_SET_NOTIFS);
export const setFloatingPaneWithMenuAndSearch = () =>
  createAction(APP_CONTROLS_MANAGER_SET_FLOATING_PANE_WITH_MENU_AND_SEARCH);

export const setSlideUpMenu = () =>
  createAction(APP_CONTROLS_MANAGER_SHOW_SLIDE_UP_MENU);
export const setWeather = () => createAction(APP_CONTROLS_MANAGER_SET_WEATHER);
export const setWeatherLocationSearch = () =>
  createAction(APP_CONTROLS_MANAGER_SET_WEATHER_LOCATION_SEARCH);

export const setTripSettings = () =>
  createAction(APP_CONTROLS_MANAGER_SET_TRIP_SETTINGS);

export const setMapOptions = () =>
  createAction(APP_CONTROLS_MANAGER_SET_MAP_OPTIONS);
export const setMapOptionsNav = () =>
  createAction(APP_CONTROLS_MANAGER_SET_MAP_OPTIONS_NAV);

export const setSafetyInformation = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SAFETY_INFORMATION);
export const setSafetyInfoNsw = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSW);
export const setSafetyInfoNswChecklist = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSW_CHECKLIST);
export const setSafetyInfoTas = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SAFETY_INFO_TAS);
export const setSafetyInfoWa = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SAFETY_INFO_WA);
export const setSafetyInfoWaDepartments = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SAFETY_INFO_WA_DEPARTMENTS);
export const setSafetyInfoNsbc = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SAFETY_INFO_NSBC);

export const setMemberDetails = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_SET_MEMBER_DETAILS, passedProps); // MemberDetails (view profile page)
export const setSettings = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SETTINGS);
export const setSettingsFeatures = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SETTINGS_FEATURES);
export const setSettingsHelm = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SETTINGS_HELM);
export const setSettingsHelmOverridePosition = () =>
  createAction(APP_CONTROLS_MANAGER_SET_SETTINGS_HELM_OVERRIDE);
export const setAbout = () => createAction(APP_CONTROLS_MANAGER_SET_ABOUT);
export const setGetNotified = () =>
  createAction(APP_CONTROLS_MANAGER_SET_GET_NOTIFIED);
export const setProfile = () => createAction(APP_CONTROLS_MANAGER_SET_PROFILE);
export const setBoatDetailsEdit = (passedProps: any) =>
  createAction(APP_CONTROLS_MANAGER_BOAT_DETAILS_EDIT, passedProps);
export const setLocationSearch = () =>
  createAction(APP_CONTROLS_MANAGER_SET_LOCATION_SEARCH);

export const setEmailAuthentication = () =>
  createAction(APP_CONTROLS_MANAGER_SET_EMAIL_AUTHENTICATION);
export const set404 = () => createAction(APP_CONTROLS_MANAGER_SET_404);

export const updateRouteLocationOnLoad = (location: any) =>
  createAction(APP_CONTROLS_MANAGER_UPDATE_ROUTE_LOCATION_ON_LOAD, location);

export const hideAllLayers = (hide: boolean) =>
  createAction(APP_CONTROLS_MANAGER_HIDE_ALL_LAYERS, hide);

export const updateSelectedBaseMapLayer = (selectedBaseMapLayer: any) =>
  createAction(
    APP_CONTROLS_MANAGER_UPDATE_SELECTED_BASE_MAP_LAYER,
    selectedBaseMapLayer,
  );
export const moveMapToLocation = (newMapLocation: any) =>
  createAction(APP_CONTROLS_MANAGER_MOVE_MAP_TO_LOCATION, newMapLocation);
export const moveMapToCurrentLocation =
  () => (dispatch: any, getState: any) => {
    const { currentPosition } = getState().geoService;
    dispatch(
      moveMapToLocation({
        center: {
          lat: +currentPosition.lat,
          lon: +currentPosition.lon,
        },
      }),
    );
  };
export const updateSelectedMarker = (selectedMarker: any) =>
  createAction(APP_CONTROLS_MANAGER_UPDATE_SELECTED_MARKER, selectedMarker);
export const updateToastMessage = (showToastMessage: any) =>
  createAction(APP_CONTROLS_MANAGER_UPDATE_TOAST_MESSAGE, showToastMessage);
export const clearMapLocationChange = () =>
  createAction(APP_CONTROLS_MANAGER_CLEAR_MAP_LOCATION_CHANGE);

export const logOutReset = () =>
  createAction(APP_CONTROLS_MANAGER_LOG_OUT_RESET);

export const showLocationMapMarker = (markerLocation: any) =>
  createAction(APP_CONTROLS_MANAGER_SHOW_LOCATION_MAP_MARKER, markerLocation);
export const updateCurrentMapParams = (mapParams: any) =>
  createAction(APP_CONTROLS_MANAGER_UPDATE_CURRENT_MAP_PARAMS, mapParams);
export const updateAppViewportSize = (viewportSize: any) =>
  createAction(APP_CONTROLS_MANAGER_UPDATE_APP_VIEWPORT_SIZE, viewportSize);

export const showSelectMapPoint = (pointRef: any) =>
  createAction(APP_CONTROLS_MANAGER_SHOW_SELECT_MAP_POINT, pointRef);

export const showControlPane = () =>
  createAction(APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE);
export const hideControlPane = () =>
  createAction(APP_CONTROLS_MANAGER_HIDE_CONTROL_PANE);
export const showControlPaneZoom = () =>
  createAction(APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_ZOOM);
export const showControlPaneReset = () =>
  createAction(APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_RESET);
export const hideControlPaneReset = () =>
  createAction(APP_CONTROLS_MANAGER_HIDE_CONTROL_PANE_RESET);
export const showControlPaneCurrentLocation = () =>
  createAction(APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_CURRENT_LOCATION);
export const showControlPaneSettings = () =>
  createAction(APP_CONTROLS_MANAGER_SHOW_CONTROL_PANE_SETTINGS);

export const showFollowButton = () =>
  createAction(APP_CONTROLS_MANAGER_SHOW_FOLLOW_BUTTON);
export const hideFollowButton = () =>
  createAction(APP_CONTROLS_MANAGER_HIDE_FOLLOW_BUTTON);

export const updateShareNotificationsStatus = (
  hasNewShareNotifications: boolean,
) =>
  createAction(
    APP_CONTROLS_UPDATE_SHARE_NOTIFICATIONS,
    hasNewShareNotifications,
  );

export const setFloatingPaneOffset = (offset: string | number) =>
  createAction(APP_CONTROLS_MANAGER_SET_FLOATING_PANE_OFFSET, offset);

export const setShowingMenuBar = (showing: boolean) =>
  createAction(APP_CONTROLS_MANAGER_SET_SHOWING_MENU_BAR, showing);

export const setDropPinLocation = (dropPinLocation: {
  latitude: number;
  longitude: number;
}) => createAction(APP_CONTROLS_MANAGER_SET_DROP_PIN_LOCATION, dropPinLocation);

interface LocationSharingSetting {
  signalMapSetting?: SignalAppearanceTypes;
  onTheWaterDetectionEnabled?: boolean;
}

export const setLocationSharingSettings = rtkCreateAction(
  APP_CONTROLS_UPDATE_PUBLIC_LOCATION,
  (setting: LocationSharingSetting) => ({
    payload: setting,
  }),
);

export const hideSearchButton = rtkCreateAction(
  APP_CONTROLS_MANAGER_HIDE_SEARCH_BUTTON,
  (hide: boolean) => ({
    payload: hide,
  }),
);

export const hideBottomControlPane = rtkCreateAction(
  APP_CONTROLS_MANAGER_HIDE_BOTTOM_CONTROL_PANE,
  (hide: boolean) => ({
    payload: hide,
  }),
);

export const setTransparentStatusBar = rtkCreateAction(
  APP_CONTROLS_SET_TRANSPARENT_STATUS_BAR,
  (transparent: boolean) => ({
    payload: transparent,
  }),
);

export const setHideStatusBar = rtkCreateAction(
  APP_CONTROLS_SET_HIDE_STATUS_BAR,
  (hide: boolean) => ({
    payload: hide,
  }),
);

export const setMemberSettings = rtkCreateAction(
  APP_CONTROLS_MANAGER_UPDATE_MEMBER_SETTINGS,
  (settings: any) => ({
    payload: settings,
  }),
);

export const updateMemberSettings = createAsyncThunk<
  void,
  Record<string, unknown>,
  AppAsyncThunkAPI
>('update member settings', async (settings, { dispatch }) => {
  // NOTE: this action used to turn signal on/off. However this is no longer required, but there are parts of the code that are currently depending on
  // this action to be async. Should be removed
  dispatch(setMemberSettings(settings));
});

/**
 * An action which actually makes the request to update member settings, unlike the actual
 * updateMemberSettings action which just updates the state and turns on signal
 */
export const postMemberSettings = createAsyncThunk<
  void,
  Partial<MemberSetting>,
  AppAsyncThunkAPI
>('post member settings', async (settings, { dispatch }) => {
  await api.postMemberSettings({
    memberSetting: settings,
  });

  dispatch(updateMemberSettings(settings));
});

/**
 * Get current sharing settings
 */
export const getMemberSignalSharingSettings = (): {
  signalMapSetting: SignalAppearanceTypes;
} => {
  try {
    const { signalMapSetting } =
      getStore().getState().appControls.memberSettings.locationConfig;
    return {
      signalMapSetting,
    };
  } catch (error) {
    return {
      signalMapSetting: SignalAppearanceTypes.Anonymous,
    };
  }
};

const getWindowHeight = () =>
  (document &&
    document.documentElement &&
    document.documentElement.clientHeight) ||
  window.innerHeight;

// This action exists for two reasons:
// 1. The viewport should only ever be updated with the values it calculates, so I abstracted that logic here. It was
// previously using `updateAppViewportSize`, which should be avoided moving forward.
// 2. There are times where the calculated size isn't right, which was causing the menu bar to be hidden. Now, we can
// dispatch this action to update the viewport size. This is currently done on the window resize event, and the mapbox
// viewport update event. Ideally we wouldn't be needing to calculate the size of the viewport
export const updateViewportSize = createAsyncThunk<
  void,
  void,
  AppAsyncThunkAPI
>('[app-controls] Update app viewport size', (_, { dispatch }) => {
  const topSafeAreaInset = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--sat') || '0',
    10,
  );
  const bottomSafeAreaInset = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue('--sab') || '0',
    10,
  );

  const height = getWindowHeight() - topSafeAreaInset - bottomSafeAreaInset;
  const width = window.innerWidth;

  dispatch(updateAppViewportSize({ width, height }));
});

export const fetchMemberSettings = createAsyncThunk<
  void,
  void,
  AppAsyncThunkAPI
>('[app-controls] fetch member settings', async (_, { dispatch }) => {
  try {
    const memberSettings = await callEndpoint(
      callEndpoint.endpoints.getMemberSettings,
    );
    if (memberSettings) {
      // Update redux with all their settings
      dispatch(updateMemberSettings(memberSettings.selectedSettings));
    }
  } catch (err) {
    telemetry(
      telemetry.ERROR,
      `[app-controls.fetchMemberSettings] error fetching and setting member settings: ${JSON.stringify(
        err,
      )}`,
    );
  }
});

export const updateHomeLocationFromPositionOrMapCenter = createAsyncThunk<
  void,
  void,
  AppAsyncThunkAPI
>(
  '[app-controls] update home location from position or map center',
  async () => {
    const { latitude, longitude } = await getCurrentPositionOrMapCenter();

    await callEndpoint(callEndpoint.endpoints.submitMemberHomeLocation, {
      homeLocation: '-',
      homeLocationCountry: '-',
      homeLocationLatLon: {
        lat: latitude,
        lon: longitude,
      },
    });
  },
);

export const updateLocationSharingSettings = createAsyncThunk<
  void,
  LocationSharingSetting,
  AppAsyncThunkAPI
>(
  'update location sharing setting',
  async (setting, { dispatch, getState }) => {
    dispatch(setLocationSharingSettings(setting));
    await api.postMemberSettings({
      memberSetting: {
        locationConfig: getState().appControls.memberSettings
          .locationConfig as MemberSettingLocationConfig,
      },
    });
    // Update current location pulse (for user)
    updateCurrentLocationPulse();

    // Force uploading events. This is because at the moment the user settings for positional data is tied
    // to the location-sharing position db. This should be changed in the future.
    // Also need to update the positions on the map. Unfortunately, it was too much of a refactor to change
    // how annon data capture uses async/await. We need to wait until the data capture is uploaded before
    // fetching the positional data. But this behaviour isn't desired everywhere, as a quick fix, I've
    // added a callback to uploadAndDelete. This will work for most cases. If all else fails, data
    // capture uploaded every 16 seconds (as of writing this comment)
    await uploadAndDelete(true, throttledFetchAndBuildDataSource);

    throttledFetchAndBuildDataSource();
  },
);
